import Script from 'next/script'

import { env } from '@/shared/config'

import { scriptLoaded } from './model'

export function FacebookSDKScript() {
    if (!env.FB_APP_ID) {
        return null
    }

    return <Script src="https://connect.facebook.net/en_US/sdk.js" strategy="afterInteractive" onLoad={scriptLoaded} />
}
